export interface ISite {
    _id?: string;
    name: string;
    domain: string;
    Integrations: Array<any>;
}

export const initialSiteObj: ISite = {
    _id:null,
    name: "",
    domain: "",
    Integrations: [],
}
